/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FullPageModal from 'app/components/common/FullPageModal.jsx';
import { FormattedNumber } from 'react-intl';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import GetPlanData from 'app/utility/GetPlanData.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import makeToast from 'app/modules/makeToast.js';

class ConfirmaitonModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updatingFrequency: false,
            frequencyIsUpdated: false,
            working: false,
            userUpdated: false,
            permsUpdated: false
        };

        this.upgradePlan = this.upgradePlan.bind(this);
        this.buttonAction = this.buttonAction.bind(this);
        this.updateFrequency = this.updateFrequency.bind(this);
        this.getLimit = this.getLimit.bind(this);
        this.getPrice = this.getPrice.bind(this);

    }

    componentDidMount() {

        if (dataLayer && this.props.confirmationType !== 'newsubscription') {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 2, 'option': 'Confirmation'}
                    }
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.plans.updatedPullFreq < this.props.plans.updatedPullFreq) {
            this.upgradePlan();
            this.setState({
                updatingFrequency: false,
                frequencyIsUpdated: true
            });
        }

        if (this.props.confirmationType === "addonchange") {
            if (prevProps && prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false) {
                let updateErrors = this.props.getApiErrors(['SUB_ADDON_UPDATE']);
                if (updateErrors.length) {
                    // toast gets added by Subscription.jsx - close the modal so it's visible
                    this.props.closeAllModals();
                } else {
                    this.props.getUserPerms();
                    this.props.getUser();
                }
            }

            if (prevProps && prevProps.app.loading.USER_FETCH === true && this.props.app.loading.USER_FETCH === false) {
                this.setState({
                    userUpdated: true
                });
            }

            if (prevProps && prevProps.app.loading.USER_FETCH_PERMS === true && this.props.app.loading.USER_FETCH_PERMS === false) {
                this.setState({
                    permsUpdated: true
                });
            }

            if (this.state.userUpdated && this.state.permsUpdated) {
                this.props.closeAllModals();
            }

        }

    }

    upgradePlan(e) {

        let data = {
                level: this.props.planLevel,
                term: this.props.planTerm,
                trackingAction: 'planupgrade'
            },
            setRequest = this.props.setRequest || null;

        if (e) {
            e.preventDefault();
        }

        this.setState({
            working: true
        });

        if (this.props.adjustedAddOns) {
            data.add_on_social = this.props.adjustedAddOns;
        }

        this.props.confirmationAction(data, setRequest);

    }

    buttonAction(e) {

        e.preventDefault();

        this.setState({
            working: true
        });

        if (this.props.addOnType !== undefined) {
            this.props.confirmationAction.apply(this, [this.props.addOnType]);
        } else {
            this.props.confirmationAction.apply(this, []);
        }


    }

    updateFrequency(e) {

        e.preventDefault();

        this.setState({
            updatingFrequency: true
        });

        this.props.updatePullFreq();

    }

    getLimit(limit) {

        return (limit === "-1" || limit === -1) ? "Unlimited" : limit;

    }

    getPrice() {

        let basePrice = 0,
            addOnPrices = {},
            socialsQuantity = 0,
            postsQuantity = 0,
            constants = this.props.app.config.constants,
            fixedDiscount = 0,
            percentDiscount = 0,
            planDetail = GetPlanData.lookupDetails(this.props.planLevel, this.props.planTerm),
            nextPrice = 0;

        basePrice = this.props.plans.details[this.props.planLevel].price[this.props.planTerm];
        if (Object.keys(this.props.plans.details[this.props.planLevel].addOnPrices).length) {
            addOnPrices = this.props.plans.details[this.props.planLevel].addOnPrices;
        }

        if (this.props.adjustedAddOns !== undefined &&
            this.props.subscription.addOns &&
            this.props.subscription.addOns.add_on_social &&
            this.props.subscription.addOns.add_on_social.qty !== this.props.adjustedAddOns
        ) {
            socialsQuantity = this.props.adjustedAddOns;
        } else if (this.props.subscription.addOns && this.props.subscription.addOns.add_on_social) {
            socialsQuantity = this.props.subscription.addOns.add_on_social.qty;
        }

        if (this.props.subscription.addOns && this.props.subscription.addOns.add_on_posts_1) {
            postsQuantity = this.props.subscription.addOns.add_on_posts_1.qty;
        }

        if (this.props.subscription.coupons !== undefined && this.props.subscription.coupons.length) {
            for (let i = 0; i < this.props.subscription.coupons.length; ++i) {
                if (this.props.subscription.coupons[i].plans.find(({code}) => {
                        return code === planDetail.plan_id;
                    }) === undefined) {
                    continue;
                }
                if (this.props.subscription.coupons[i].type === 'fixed') {
                    fixedDiscount += this.props.subscription.coupons[i].currencies[0].amount;
                } else if (this.props.subscription.coupons[i].type === 'percent') {
                    percentDiscount += this.props.subscription.coupons[i].percent;
                }
            }
            percentDiscount = ((100 - percentDiscount) / 100);
        }

        nextPrice = basePrice;

        if (addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
            nextPrice += socialsQuantity * addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][this.props.planTerm];
        }

        if (addOnPrices[constants.SUBSCRIPTION_ADDON_POSTS_1] !== undefined) {
            nextPrice += postsQuantity * addOnPrices[constants.SUBSCRIPTION_ADDON_POSTS_1][this.props.planTerm];
        }

        if (fixedDiscount) {
            nextPrice -= fixedDiscount;
        }

        if (percentDiscount) {
            let discountPrice = (nextPrice * percentDiscount),
                discountParts = discountPrice.toString().split("."),
                discountCents = (discountParts[1] !== undefined) ? discountParts[1].substring(0, 2) : '00';

            nextPrice = `${discountParts[0]}.${discountCents}`;
        }

        return nextPrice;

    }

    render() {
        let constants = this.props.app.config.constants,
            content = null,
            title = '',
            updatingFrequency = null,
            term = this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL ? 'per year' : 'per month',
            buttonLabel = null,
            message = '',
            confirmationMessage = '',
            savingsPct = 0;

        let annualPrice = this.props.plans.details[this.props.planLevel].price[constants.SUBSCRIPTION_TERM_ANNUAL],
            monthlyPrice = this.props.plans.details[this.props.planLevel].price[constants.SUBSCRIPTION_TERM_MONTHLY];

        if (!this.props.isProUser()) {
            let monthlyAnnual = monthlyPrice * 12,
                savings = monthlyAnnual - annualPrice;

            savingsPct = ((savings / monthlyAnnual) * 100).toFixed(0);

        } else {
            savingsPct = 33;
        }

        if (this.props.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
            term = ' for trial duration';
        }

        if (this.state.working) {
            buttonLabel = (<i className="fa fa-spinner fa-pulse"></i>);
        } else {
            if (this.props.confirmationType === 'newsubscription') {
                buttonLabel = 'OK';
            } else {
                buttonLabel = 'Confirm';
            }
        }

        if (this.props.confirmationType === 'termupdate') {
            title = "Plan Change";
            if (this.props.app.loading.SUB_FETCH_DETAIL) {
                content = (
                    <Loading/>
                );
            } else {
                let price = this.getPrice(),
                    termBilling = this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL ? 'annual' : 'monthly',
                    savings = null,
                    confirmationMessage = "You'll receive a credit for the prorated amount of the annual plan. Don't worry, you won't be charged twice!";

                if (this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) {
                    savings = ` saving you ${savingsPct}% over monthly billing`;
                    confirmationMessage = "You'll be charged a prorated amount for your updated plan. Don't worry, you won't be charged twice!";
                }

                content = (
                    <div className="confirmation-block">
                        <div className="confirmation-main">
                            Great, we'll switch you to {termBilling} billing {savings}
                        </div>
                        <div className="confirmation-detail">
                            You get <span className="callout">{this.getLimit(this.props.currentLimits.outputs)} Socials</span> and <span className="callout">{this.getLimit(this.props.currentLimits.inputs)} Feeds & Sites</span> for
                            just <FormattedNumber value={price} style="currency" currency="USD"/> {term}
                        </div>
                        <div className="confirmation-fine-print">
                            {confirmationMessage}
                        </div>
                        <div className="confirmation-button">
                            <button className="btn-primary active fixed" onClick={this.upgradePlan}>
                                {buttonLabel}
                            </button>
                        </div>
                    </div>
                );
            }
        } else if (this.props.confirmationType === 'newsubscription') {
            title = "Plan Change";
            if (this.props.app.loading.SUB_FETCH_DETAIL) {
                content = (
                    <Loading/>
                );
            } else {
                if (!this.props.isBasicUser(this.props.planLevel) && !this.props.isStarterUser(this.props.planLevel)) {
                    if (this.state.updatingFrequency) {
                        updatingFrequency = "... Updating Your Feeds ...";
                    } else if (this.state.frequencyIsUpdated) {
                        updatingFrequency = "We're checking your feeds every " + this.props.plans.details[this.props.planLevel].limits.pullFrequencyList[0] + " minutes";
                    } else {
                        updatingFrequency = (
                            <span>Your new items will post even faster! We'll check feeds every {this.props.plans.details[this.props.planLevel].limits.pullFrequencyList[0]} minutes.</span>
                        );
                    }
                    content = (
                        <div className="confirmation-block">
                            <div className="block-accent"></div>
                            <div className="confirmation-main">
                                Great, we're excited for you to share better with<br/>dlvr.it {this.props.plans.details[this.props.planLevel].label}.
                            </div>
                            <div className="confirmation-detail">
                                {updatingFrequency}
                            </div>
                            <div className="confirmation-button clearfix">
                                <button className="btn-primary reverse-fixed left" onClick={this.upgradePlan}>
                                    Keep current speeds
                                </button>
                                <button className="btn-primary active fixed right" onClick={this.updateFrequency}>
                                    OK! Get faster updates
                                </button>
                            </div>
                        </div>
                    );
                } else {
                    content = (
                        <div className="confirmation-block">
                            <div className="block-accent"></div>
                            <div className="confirmation-main">
                                Great, we're excited for you to share better with<br/>dlvr.it {this.props.plans.details[this.props.planLevel].label}.
                            </div>
                            <div className="confirmation-button clearfix">
                                <button className="btn-primary active fixed" onClick={this.props.confirmationAction}>
                                    OK!
                                </button>
                            </div>
                        </div>
                    );
                }

            }

        } else if (this.props.confirmationType === 'planupgrade' || this.props.confirmationType === 'addonchange') {
            title = "Plan Change";
            if (this.props.plans.details[this.props.planLevel].loading) {
                content = (
                    <Loading/>
                );
            } else {
                let price = this.getPrice(),
                    action = this.props.user.detail.subscriptionState == constants.SUBSCRIPTION_CANCELLED ? 'restart' : 'update',
                    // headline = "Great, we'll switch you to the " + this.props.plans.details[this.props.planLevel].label + " Plan.",
                    headline = "You're all set!",
                    finePrint = "You'll receive a credit for your current subscription and the new subscription price will be prorated for the current billing cycle.",
                    trialInfo = null,
                    now = new Date(),
                    detail = null,
                    inputs = 0,
                    outputs = 0,
                    buttonAction = this.upgradePlan;

                if (Object.keys(this.props.newLimits).length > 0) {
                    inputs = this.props.newLimits.inputs;
                    outputs = this.props.newLimits.outputs;
                    price = this.props.newLimits.price;
                } else {
                    inputs = this.getLimit(this.props.plans.details[this.props.planLevel].limits.hardLimitInputs);
                    outputs = this.getLimit(this.props.plans.details[this.props.planLevel].limits.hardLimitOutputs);
                }

                if (inputs === -1) {
                    inputs = "Unlimited";
                }
                if (outputs === -1) {
                    outputs = "Unlimited";
                }

                if (action === 'restart') {
                    headline = "Great, we'll restart your " + this.props.plans.details[this.props.planLevel].label + " Plan.";
                    finePrint = '';
                }

                if (this.props.confirmationType === 'planupgrade') {
                    if ((this.props.isPlusUser(this.props.planLevel) || this.props.isAgencyPlusUser(this.props.planLevel))) {
                        headline = "Excellent choice";
                        detail = (
                            <span>
                                <p>You get {outputs} Socials and {inputs} Feeds & Sites, Everqueue, Categories, and Content Import to supercharge your automation workflow.</p>
                            </span>
                        );
                    } else if (this.props.user.perms.resources.plusTrialAvailable && (this.props.isPlusUser(this.props.planLevel) || this.props.isAgencyPlusUser(this.props.planLevel))) {
                        trialInfo = (
                            <p>Enjoy all the features of {this.props.plans.details[this.props.planLevel].label} for the rest of your trial. Billing will occur at the end of your trial period.</p>
                        );
                        finePrint = '';
                    }
                } else {
                    buttonAction = this.buttonAction;
                }

                // You're now on the Plus plan with 30 social outputs and 50 additional X Posts.
                if (!detail) {
                    if (this.props.newLimits.addOnPosts > 0) {
                        detail = (
                            <span>
                                You're on the {this.props.plans.details[this.props.planLevel].label} plan with <span className="callout">{outputs} social outputs</span> and <span className="callout"> {this.props.newLimits.addOnPosts} additional X Posts</span>.
                            </span>
                        );
                    } else {
                        detail = (
                            <span>
                                You're on the {this.props.plans.details[this.props.planLevel].label} plan with <span className="callout">{outputs} social outputs</span>.
                            </span>
                        );
                    }
                }

                content = (
                    <div className="confirmation-block">
                        <div className="confirmation-main">
                            {headline}
                        </div>
                        <div className="confirmation-detail">
                            {detail}
                        </div>
                        <div className="confirmation-fine-print">
                            {finePrint}
                        </div>
                        <div className="confirmation-button">
                            <button className="btn-primary active fixed" onClick={buttonAction}>
                                {buttonLabel}
                            </button>
                        </div>
                    </div>
                );
            }

        } else if (this.props.confirmationType === 'newpaidsubscription') {
            title = "Plan Change";
            if (this.props.plans.details[this.props.planLevel].loading) {
                content = (
                    <Loading/>
                );
            } else {
                if (this.state.updatingFrequency) {
                    updatingFrequency = "... Updating Your Feeds ...";
                } else if (this.state.frequencyIsUpdated) {
                    updatingFrequency = "We're checking your feeds every " + this.props.plans.details[this.props.planLevel].limits.pullFrequencyList[0] + " minutes";
                } else {
                    updatingFrequency = (
                        <span>Your new items will post even faster! We'll check feeds every {this.props.plans.details[this.props.planLevel].limits.pullFrequencyList[0]} minutes.</span>
                    );
                }
                content = (
                    <div className="confirmation-block">
                        <div className="block-accent"></div>
                        <div className="confirmation-main">
                            Great, we're excited for you to continue<br/>sharing better with dlvr.it {this.props.plans.details[this.props.planLevel].label}.
                        </div>
                        <div className="confirmation-detail">
                            {updatingFrequency}
                        </div>
                        <div className="confirmation-button clearfix">
                            <button className="btn-primary reverse-fixed left" onClick={this.upgradePlan}>
                                Keep current speeds
                            </button>
                            <button className="btn-primary active fixed right" onClick={this.updateFrequency}>
                                OK! Get faster updates
                            </button>
                        </div>
                    </div>
                );
            }
        }

        return (
            <FullPageModal
                content={content}
                version="headerless"
                closeAction={() => {
                    if (this.props.onConfirmationCancel !== undefined) {
                        this.props.onConfirmationCancel();
                    }
                    this.props.closeAllModals();
                }} />
        );
    }

};

ConfirmaitonModal.displayName = "ConfirmaitonModal";

ConfirmaitonModal.propTypes = {
    confirmationType: PropTypes.string,
    confirmationAction: PropTypes.func,
    updatedSubscription: PropTypes.object,
    planLevel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    planTerm: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    planAddOns: PropTypes.number,
    newLimits: PropTypes.object,
    currentLimits: PropTypes.object,
    currentSubscription: PropTypes.object
};

ConfirmaitonModal.defaultProps = {
    confirmationType: '',
    confirmationAction: null,
    subscription: {},
    planLevel: '',
    planTerm: '',
    planAddOns: 0,
    newLimits: {},
    currentLimits: {}
};

export default ConfirmaitonModal;
